import { useEffect, useState } from 'react';
import Api from 'services/api';
import { BiddingTaskTypes } from 'store/modules/bidding_store/types';

export function useTaskDetail(taskId: number | null) {
  const [task, setTask] = useState<BiddingTaskTypes | null>(null);
  const [loading, setLoading] = useState(!!taskId);
  const [error, setError] = useState(false);

  useEffect(() => {
    setTask(null);
    setError(false);

    if (!taskId) {
      setLoading(false);
      return undefined;
    }

    let active = true;
    setLoading(true);
    Api.get(`/gestao_ia/tarefas/${taskId}`)
      .then((response) => {
        if (!active) return;
        const detail = response?.data?.task ?? response?.data;
        if (response?.status === 200 && detail?.id) {
          setTask(detail);
        } else {
          setError(true);
        }
      })
      .catch(() => {
        if (active) setError(true);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [taskId]);

  const replace = (updated: BiddingTaskTypes) => setTask(updated);

  return { task, loading, error, replace };
}
